export default class Filter {}
